import { slideDown, slideUp } from 'theme-utilities';

const selectors = {
	accordion: '.accordion',
	tab: '.tab',
	tabMeta: '.tab__meta',
	tabContent: '.tab__content',
};

const openClass = 'open';
const slideDuration = 500;

const openTab = (tabElement) => {
	if (!tabElement) {
		return;
	}
	tabElement.classList.add(openClass);
	slideDown(tabElement.querySelector(selectors.tabContent), slideDuration);
};

const closeTab = (tabElement) => {
	if (!tabElement) {
		return;
	}
	tabElement.classList.remove(openClass);
	slideUp(tabElement.querySelector(selectors.tabContent), slideDuration);
};

const tabIsOpen = (tabElement) => tabElement.classList.contains(openClass);

document.querySelectorAll(selectors.accordion).forEach((accordion) => {
	const allowMultipleOpenTabs = accordion.classList.contains('accordion--allow-multiple');
	const defaultOpenTabIndex = parseInt(accordion.getAttribute('data-start-index'));

	// Open tab if start-index is not 0
	if (defaultOpenTabIndex) {
		openTab(accordion.querySelector(`${selectors.tab}:nth-child(${defaultOpenTabIndex})`));
	}

	accordion.querySelectorAll(selectors.tabMeta).forEach((tabHeader) => {
		tabHeader.addEventListener('click', () => {
			if (tabIsOpen(tabHeader.closest(selectors.tab))) {
				// If tab is already open, close it
				closeTab(tabHeader.closest(selectors.tab));
			} else {
				// Close all tabs if multiple open tabs are not allowed
				if (!allowMultipleOpenTabs) {
					accordion.querySelectorAll(selectors.tab).forEach((tab) => {
						tabIsOpen(tab) && closeTab(tab);
					});
				}

				// Open clicked tab
				openTab(tabHeader.closest(selectors.tab));
			}
		});
	});
});
